import {useMemo} from 'react';
import type {ThesaurusAction} from 'types';
import type {SceneExtensionCore} from 'sceneExtensions/types';
import {FieldExtensionEnum} from 'sceneExtensions/types';
import type {ThesaurusValue} from 'schemaDefinition/types';
import {ColorPalette} from 'theme';
import type {
  ThesaurusEditContainerConfig,
  ThesaurusFieldConfig,
} from '../types';
import {ThesaurusEditContainer} from '../ThesaurusEditContainer';
import {useThesaurusMetadataFieldExtension} from './useThesaurusMetadataFieldExtension';

export const useThesaurusEditSceneExtensionCore = (
  config?: ThesaurusEditContainerConfig,
) => {
  const thesaurusMetadataFieldExtension = useThesaurusMetadataFieldExtension();

  return useMemo((): SceneExtensionCore<
    FieldExtensionEnum.thesaurusEdit,
    ThesaurusValue,
    ThesaurusValue,
    ThesaurusAction,
    ThesaurusFieldConfig
  > => {
    return {
      type: FieldExtensionEnum.thesaurusEdit,
      panelConfig: {
        backgroundColour: ColorPalette.enhancedBrown,
      },
      renderRightPanel: (onClose: () => Promise<void>) => (
        <ThesaurusEditContainer onClose={onClose} config={config} />
      ),
      fieldContext: thesaurusMetadataFieldExtension,
    };
  }, [thesaurusMetadataFieldExtension, config]);
};
